document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-m-comparison-table]');

  if (!sections.length) return;

  sections.forEach(function (section) {
    var button = section.querySelector('[data-scroll-target]');
    if (button) {
      button.addEventListener('click', function (event) {
        var targetId = button.getAttribute('data-scroll-target');
        if (!targetId) return;

        var target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var scrollWrap = section.querySelector('[data-m-comparison-scroll-wrap]');
    var hint = section.querySelector('[data-m-comparison-scroll-hint]');
    var thumb = section.querySelector('.m-comparison-table__mobile-scroll-thumb');

    if (!scrollWrap || !hint || !thumb) return;

    function updateThumb() {
      var maxScroll = scrollWrap.scrollWidth - scrollWrap.clientWidth;

      if (window.innerWidth > 749 || maxScroll <= 0) {
        hint.style.display = 'none';
        thumb.style.transform = 'translateX(0)';
        return;
      }

      hint.style.display = 'flex';

      var progress = scrollWrap.scrollLeft / maxScroll;
      var track = hint.querySelector('.m-comparison-table__mobile-scroll-track');
      if (!track) return;

      var trackWidth = track.offsetWidth;
      var thumbWidth = thumb.offsetWidth;
      var moveX = (trackWidth - thumbWidth) * progress;

      thumb.style.transform = 'translateX(' + moveX + 'px)';
    }

    scrollWrap.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
    updateThumb();
  });
});